import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class AddReceivingPersonMoo implements IFlagFeature {
  name = Features.ADD_RECEIVING_PERSON_MOO;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class DeliveryInstructionsFieldMoo implements IFlagFeature {
  name = Features.DELIVERY_INSTRUCTIONS_FIELD_MOO;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class OrderDetailLinkMOOFeature implements IFlagFeature {
  name = Features.ORDER_DETAIL_LINK_MOO;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class RestrictedJobsiteMoo implements IFlagFeature {
  name = Features.RESTRICTED_JOBSITE_MOO;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class CertifiedTrucksDriversMoo implements IFlagFeature {
  name = Features.CERTIFIED_TRUCKS_DRIVERS_MOO;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class EnableDefaultTimeAddMooFeature implements IFlagFeature {
  name = Features.DEFAULT_TIME_ADD_MOO;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class EnableDefaultTimeDuplicateMooFeature implements IFlagFeature {
  name = Features.DEFAULT_TIME_DUPLICATE_MOO;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class AutoSelectJobsiteMoo implements IFlagFeature {
  name = Features.AUTO_SELECT_JOBSITE_MOO;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class SetNonWorkingDaysPickerMooFeature implements IFlagFeature {
  name = Features.SET_NON_WORKING_DAYS_PICKER_MOO;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class MOOPrefillFeature implements IFlagFeature {
  name = Features.PREFILL_MOO;
  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}

@Injectable()
export class SameDayMOOFeature implements IFlagFeature {
  name = Features.SAME_DAY_MOO;
  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
